import React from "react";
// import { Link } from "react-router-dom";




export default class EventDetails extends React.Component {

    render(){
        return(
            <div>
                <div class="wrapper">
                    <section class="bread-crumb-container">
                        <div class="bread-crumb-img">
                            <img src="/assets/images/bread-crumb3.png" alt=""/>
                        </div>
                        <div class="bread-crumb-content">
                            <div class="bread-crumb-inner">
                            <h2>Event Detail</h2>
                            <a href="index.html">Home</a> - <a href="event-detail.html">Event Detail</a>
                            </div>
                        </div> {/* <!-- bread-crumb-content --> */}
                    </section> {/* <!-- bread-crumb-container --> */}
                    <div class="main-part">
                    <section class="event-container">
                        <div class="container">
                        <div class="event-detail-wrap">
                            <div class="event-list wow fadeInDown text-left" data-wow-duration="1000ms" data-wow-delay="300ms">
                            <div class="event-pic">
                                <img src="/assets/images/event1.jpg" alt=""/>
                            </div>
                            <h3>We went to all the weddings on 17th</h3>
                            <span>17 august 2016</span>
                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p>
                            <p><i>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</i></p>
                            <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.</p>
                            <p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p>
                            </div> {/* <!-- event-list --> */}
                            <div class="pn-link">
                            <div class="prev-link"><a href="#/" class="btn-black">Previous event</a></div><div class="next-link"><a href="#/" class="btn-black">Next event</a></div>  
                            </div>
                        </div> {/* <!-- event-wrap --> */}
                        </div>
                    </section> {/* <!-- event-container --> */}
                    <div class="map-outer">
                        <div id="truck-locator"></div>
                    </div>
                    </div> {/* <!-- main-part --> */}
                </div>
            </div>
        )
    }
}